export default {"src":"/_next/static/media/music_note.a1571662.svg","height":16,"width":13,"blurWidth":0,"blurHeight":0};